<template>

    <div class="letter-namings">
        <iframe class="mt-4" style="width: 100%; height: 550px"
                src="https://www.interventioncentral.org/rti2/letterNamings">
        </iframe>
    </div>

</template>

<script>

    /**
     * Legacy tool - does not use the new document machinery, just displays an old
     * CakePHP-based tool in an iframe.
     */
    import Vue from 'vue'

    export default Vue.extend({
        name: "LetterNamings",
    })

</script>


